import { createSlice } from "@reduxjs/toolkit";
import axios from "../../utils/axios";

const backendUrl = process.env.REACT_APP_BACKEND_URL_V2;

const initialState = {
  isLoading: false,
  error: null,
  boms: [],
  bom: null,
  page: 1,
  limit: 10,
  totalPages: 0,
  totalResults: 0,
};

const slice = createSlice({
  name: "bom",
  initialState,
  reducers: {
    startLoading(state) {
      state.isLoading = true;
      state.error = null;
    },

    startBomLoading(state) {
      state.isLoading = true;
      state.error = null;
      state.bom = null;
    },

    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    finishLoading(state) {
      state.isLoading = false;
      state.error = null;
    },

    getBomsSuccess(state, action) {
      state.isLoading = false;
      state.boms = JSON.parse(JSON.stringify(action.payload.results || action.payload.result || action.payload || []));
      state.page = action.payload.page || 1;
      state.limit = action.payload.limit || 10;
      state.totalPages = action.payload.totalPages || 0;
      state.totalResults = action.payload.totalResults || 0;
    },

    getBomSuccess(state, action) {
      state.isLoading = false;
      state.bom = JSON.parse(JSON.stringify(action.payload.result || action.payload));
    },
  },
});

export default slice.reducer;

export function getCatalogBoms({ franchiseId, page = 1, limit = 10 }) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(`${backendUrl}/franchise/bom`, {
        params: {
          franchiseId,
          page,
          limit,
        },
      });

      dispatch(slice.actions.getBomsSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error?.message || "Unable to load BOMs."));
    }
  };
}

export function createCatalogBom({ franchiseId, payload }) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post(`${backendUrl}/franchise/bom`, payload, {
        params: { franchiseId },
      });

      dispatch(slice.actions.finishLoading());
      return response.data;
    } catch (error) {
      const message = error?.message || "Unable to create BOM.";
      dispatch(slice.actions.hasError(message));
      throw error;
    }
  };
}

export function getCatalogBom({ franchiseId, bomId }) {
  return async (dispatch) => {
    dispatch(slice.actions.startBomLoading());
    try {
      const response = await axios.get(`${backendUrl}/franchise/bom/${bomId}`, {
        params: { franchiseId },
      });

      dispatch(slice.actions.getBomSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error?.message || "Unable to load BOM."));
    }
  };
}

export function updateCatalogBom({ franchiseId, bomId, payload }) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.patch(`${backendUrl}/franchise/bom/${bomId}`, payload, {
        params: { franchiseId },
      });

      dispatch(slice.actions.finishLoading());
      return response.data;
    } catch (error) {
      const message = error?.message || "Unable to update BOM.";
      dispatch(slice.actions.hasError(message));
      throw error;
    }
  };
}
